var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-content__wrap",attrs:{"id":"app"}},[(_vm.showHeaderAndFooter)?_c('Header'):_c('Header2'),_c('router-view'),_c('Footer'),_c('CookieBanner'),(!this.isMobile)?_c('SocialMediaIcons'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }